import axios from "axios";
import { HostURL_API } from "../../config/appSettings"
import { encryptObject } from "../../common/commonHelper";
import { AppLocalStorage, AppLocalStorageItems } from "../../helpers/localStorageHelper";
import { AppRoutes } from "../../routingInfo/routes";
import { Buffer } from 'buffer';
import CryptoJS from 'crypto-js';
import { setRefreshToken } from "../../store/auth/authSlice";
import { HttpRequestType } from "./RequestStatus";

export const Axios = axios;
let store
export const injectStore = _store => {
  store = _store
}

const axiosHttpClient = axios.create({
  baseURL: `${HostURL_API}`,
});



const _options = {
  headers: {},
  data: {},
  cancelToken: Axios.CancelToken
}
export const HttpClient = {
  GET: (url, options = _options) => {
    return callAPI(url, HttpRequestType.GET, options)
  },
  POST: (url, options = _options) => {
    return callAPI(url, HttpRequestType.POST, options)
  },
  ANY: (method, url, options = _options) => {
    return callAPI(url, method, options)
  }
}

axiosHttpClient.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        ...config.headers,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosHttpClient.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const timeStamp = Date.now();
      AppLocalStorage.setStorageItem('lastActivityTimeStamp', timeStamp);
    }
    // console.log(store.getState().auth)
    if (response.status === 401) {
      const timeStamp = +AppLocalStorage.getStorageItem('tokenValidityInMin') * 60 * 1000;
      if (Date.now() - AppLocalStorage.getStorageItem('lastActivityTimeStamp') >= timeStamp) {
        AppLocalStorage.clearLocalStorage();
        window.location = AppRoutes.signIn;
        return response;
      } else {
        let retryReq = response.config;

        return refreshAccessToken(timeStamp).then((token) => {
          response.config.headers['authorization'] = token;
          return axiosHttpClient(retryReq);
        });

        // alert(token)

      }
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      AppLocalStorage.clearLocalStorage();
      window.location = AppRoutes.signIn;
    }
    return Promise.reject(error);
  }
);

async function callAPI(url, method, options) {
  const { headers, data } = options;
  let request = { method, url, headers: { 'Content-Type': 'application/json', ...headers } };
  if (method !== HttpRequestType.GET) {
    request['data'] = await encryptRequestObject(data);
  }
  const result = await axiosHttpClient({
    ...request,
    validateStatus: function (status) {
      return true;
    }
  });
  return {
    'data': result.data,
    'status': result.status,
    'statusText': result.statusText,
    'headers': result.headers,
    _o: result
  }
}
export const encryptRequestObject = async function (data) {

  const publicKey = CryptoJS.enc.Base64.parse(AppLocalStorage.getStorageItem("authKey")).toString(CryptoJS.enc.Utf8);
  const enableAuthKey = CryptoJS.enc.Base64.parse(AppLocalStorage.getStorageItem("enableAuthKey")).toString(CryptoJS.enc.Utf8);
  const reqEncryptData = (enableAuthKey && publicKey) ? { data: data && await encryptObject(data, publicKey).then((result) => { return result }) || {} } : data || {}
  return reqEncryptData;

}

const obj_lock = {
  isProgress: false, token: null
}

const refreshAccessToken = (timeStampConfig) => {
  let authPromise = null;
  if (!obj_lock.isProgress) {
    obj_lock.isProgress = true;
    authPromise = axiosHttpClient.post("/auth/refreshKey", { email: store.getState().auth.userInfo.email })
  }
  const payloadData = (token) => {
    const dataObject = {
      token: token,
      timestamp: Date.now()
    }
    AppLocalStorage.setStorageItem(AppLocalStorageItems.RefreshTokenTimeStamp, dataObject.timestamp)
    store.dispatch(setRefreshToken(dataObject))
  }
  return new Promise((resolve, reject) => {
    const refreshTokenTimeStamp= AppLocalStorage.getStorageItem(AppLocalStorageItems.RefreshTokenTimeStamp)
    let datetime = new Date((parseInt(refreshTokenTimeStamp) || 0) + timeStampConfig-50000);
    if (authPromise && Date.now()>datetime) {
      authPromise.
        then((res) => {
          obj_lock.token = res.data
          resolve(res.data);
          payloadData(res.data);

          let timeout_reset = setTimeout(() => {
            obj_lock.token = null;
            obj_lock.isProgress = false;
            clearTimeout(timeout_reset);
          }, 20000);
        })
    }
    else if (obj_lock.token) {
      payloadData(obj_lock.token)
      resolve(obj_lock.token)
    }

  });
};

